/**
 * DCIP controller MAC helpers — client mirror of the backend's
 * `_normalize_mac` (connectors/axema/api.py): separators stripped, lowercased,
 * valid only when exactly 12 hex digits remain. The bind route normalizes
 * server-side too; normalizing here keeps validation errors local and sends
 * the canonical form.
 */

import { relativeTime } from './format'

/** MAC -> canonical 12-lowercase-hex-digit form, null when malformed. */
export function normalizeMac(value: string): string | null {
  const raw = value
    .trim()
    .toLowerCase()
    .replace(/[^0-9a-f]/g, '')
  return raw.length === 12 ? raw : null
}

/** Canonical 12-hex-digit form -> `aa:bb:cc:dd:ee:ff` display form.
 *  Anything else passes through unchanged. */
export function formatMac(mac: string): string {
  const normalized = normalizeMac(mac)
  if (normalized === null) return mac
  return normalized.replace(/(..)(?=.)/g, '$1:')
}

/** One-line option label for a pending-controller pick-list row:
 *  "aa:bb:cc:dd:ee:ff · node 7 · last seen 5m ago · 3 sightings"
 *  (node/sightings segments omitted when absent/trivial). */
export function pendingControllerLabel(
  p: { mac: string; node_address: number | null; last_seen: string; sightings: number },
  now?: number,
): string {
  const parts = [formatMac(p.mac)]
  if (p.node_address !== null) parts.push(`node ${p.node_address}`)
  parts.push(`last seen ${relativeTime(p.last_seen, now)}`)
  if (p.sightings > 1) parts.push(`${p.sightings} sightings`)
  return parts.join(' · ')
}
